/**
 * Resolve course API base URL from env.
 * Supports REACT_APP_API_URL (host only), REACT_APP_API_BASE_URL, REACT_APP_BASE_URL.
 * Always returns a URL ending with /api.
 */
export function getCourseBaseUrl() {
  const raw =
    process.env.REACT_APP_API_URL ||
    process.env.REACT_APP_API_BASE_URL ||
    process.env.REACT_APP_BASE_URL ||
    'https://api.mazraaonline.com';

  const cleaned = String(raw).replace(/\/+$/, '');
  return cleaned.endsWith('/api') ? cleaned : `${cleaned}/api`;
}
